import { DeviceMobile } from "@phosphor-icons/react";
import { useIsMobile, useIsPortrait } from "@/hooks/useMediaQuery";

/**
 * RotatePhoneOverlay — full-screen "please rotate your phone" UI shown only
 * to PHONES (≤767px wide) in PORTRAIT orientation. Tablets (≥768px) are NOT
 * forced to landscape because they have enough real-estate for portrait.
 *
 * This is a soft-lock — installed PWA users get a real OS-level rotation
 * lock via manifest.json `orientation: "landscape"`. This overlay handles
 * the browser-tab case where we can't request true orientation lock.
 */
export default function RotatePhoneOverlay() {
  const isMobile = useIsMobile();
  const isPortrait = useIsPortrait();
  if (!isMobile || !isPortrait) return null;
  return (
    <div
      data-testid="rotate-phone-overlay"
      className="fixed inset-0 z-[9998] bg-[#050505] text-white flex flex-col items-center justify-center px-8 text-center"
      // Inline style so this stays in front of leaflet's z-index stack
      style={{ touchAction: "none" }}
    >
      <div
        className="w-20 h-20 border border-red-500/40 flex items-center justify-center mb-6 bg-red-500/10"
        style={{ animation: "rotateNudge 2s ease-in-out infinite" }}
      >
        <DeviceMobile size={42} weight="bold" className="text-red-400" />
      </div>
      <div className="mono text-[10px] uppercase tracking-[0.3em] text-zinc-500 mb-2">
        DISPATCH-911
      </div>
      <h2 className="text-xl font-bold mb-2 tracking-tight">Rotate Your Device</h2>
      <p className="text-sm text-zinc-400 max-w-xs leading-relaxed">
        Dispatch 911 plays best in landscape on phones. Turn your phone sideways to continue.
      </p>
      <p className="mono text-[10px] uppercase tracking-widest text-zinc-600 mt-6">
        Tip — install this app to your home screen for automatic landscape mode.
      </p>
      <style>{`
        @keyframes rotateNudge {
          0%, 100% { transform: rotate(0deg); }
          50% { transform: rotate(90deg); }
        }
      `}</style>
    </div>
  );
}
